(function ($) {
    let previousWidth = 0;
    $(window).on('resize', onResize);

    function onResize() {
        if (previousWidth < 768 && $(window).width() > 768) {
            $('.woocommerce-product-gallery ol').appendTo('.summary.entry-summary');
        } else if ((previousWidth === 0 || previousWidth > 768) && $(window).width() < 768) {
            $('.woocommerce-product-gallery ol').appendTo('.woocommerce-product-gallery');
        }
        previousWidth = $(window).width();
    }

    $(document).ready(function () {
        onResize();
        $('#review-form-container').on('click', function () {
            $(this).toggleClass('open');
        });
    });
})(jQuery);
